import React, { useEffect, useState } from 'react';
import { photographerAPI } from '../services/api';

const Datenschutz = () => {
  const [datenschutz, setDatenschutz] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchDatenschutz();
  }, []);

  const fetchDatenschutz = async () => {
    try {
      const response = await photographerAPI.getInfo();
      setDatenschutz(
        response.info.datenschutz ||
          'Die Datenschutzerklärung wird derzeit bearbeitet.'
      );
    } catch (error) {
      console.error('Error fetching datenschutz:', error);
      setDatenschutz('Datenschutzerklärung konnte nicht geladen werden.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-20" data-testid="datenschutz-page">
      {/* Hero Section */}
      <section className="section-spacing-large bg-gray-50">
        <div className="photo-container text-center">
          <h1 className="hero-title mb-6">Datenschutzerklärung</h1>
          <p className="subtitle max-w-2xl mx-auto">
            Informationen zur Verarbeitung Ihrer personenbezogenen Daten nach DSGVO
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="section-spacing">
        <div className="photo-container">
          <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-sm p-8">
            {loading ? (
              <p className="text-center text-gray-500">Wird geladen...</p>
            ) : (
              <div className="prose max-w-none">
                <pre
                  data-testid="datenschutz-content"
                  className="whitespace-pre-wrap font-body text-gray-700 leading-relaxed"
                >
                  {datenschutz}
                </pre>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Datenschutz;
